import moment from "moment";

export function fixCurrentPage() {
    const paging = this.props.data[this.id].pagination;
    const isFixCurrentPage = (paging.total > 1 // not the last record on Total
        && paging.current === Math.ceil(paging.total / paging.pageSize) // last page
        && 1 === paging.total % paging.pageSize // last record on page
    );

    if (isFixCurrentPage) {
        this.props.dataActions.genericDataSetFilter(
            this.id,
            this.props.user.companyCode,
            this.props.user.token, {
            page: paging.current - 1,
            _page_num: paging.current - 1,
        },
            this.api.get
        );
    }
}

const coloursJSON = {
    "aliceblue": "#f0f8ff", "antiquewhite": "#faebd7", "aqua": "#00ffff", "aquamarine": "#7fffd4", "azure": "#f0ffff",
    "beige": "#f5f5dc", "bisque": "#ffe4c4", "black": "#000000", "blanchedalmond": "#ffebcd", "blue": "#0000ff", "blueviolet": "#8a2be2", "brown": "#a52a2a", "burlywood": "#deb887",
    "cadetblue": "#5f9ea0", "chartreuse": "#7fff00", "chocolate": "#d2691e", "coral": "#ff7f50", "cornflowerblue": "#6495ed", "cornsilk": "#fff8dc", "crimson": "#dc143c", "cyan": "#00ffff",
    "darkblue": "#00008b", "darkcyan": "#008b8b", "darkgoldenrod": "#b8860b", "darkgray": "#a9a9a9", "darkgreen": "#006400", "darkkhaki": "#bdb76b", "darkmagenta": "#8b008b", "darkolivegreen": "#556b2f",
    "darkorange": "#ff8c00", "darkorchid": "#9932cc", "darkred": "#8b0000", "darksalmon": "#e9967a", "darkseagreen": "#8fbc8f", "darkslateblue": "#483d8b", "darkslategray": "#2f4f4f", "darkturquoise": "#00ced1",
    "darkviolet": "#9400d3", "deeppink": "#ff1493", "deepskyblue": "#00bfff", "dimgray": "#696969", "dodgerblue": "#1e90ff",
    "firebrick": "#b22222", "floralwhite": "#fffaf0", "forestgreen": "#228b22", "fuchsia": "#ff00ff",
    "gainsboro": "#dcdcdc", "ghostwhite": "#f8f8ff",
    "gold": "#ffd700", "#ffc300": "#ffc300", "#ddc268": "#ddc268",
    "goldenrod": "#daa520", "gray": "#808080", "green": "#008000", "greenyellow": "#adff2f",
    "honeydew": "#f0fff0", "hotpink": "#ff69b4",
    "indianred ": "#cd5c5c", "indigo": "#4b0082", "ivory": "#fffff0", "khaki": "#f0e68c",
    "lavender": "#e6e6fa", "lavenderblush": "#fff0f5", "lawngreen": "#7cfc00", "lemonchiffon": "#fffacd", "lightblue": "#add8e6", "lightcoral": "#f08080", "lightcyan": "#e0ffff", "lightgoldenrodyellow": "#fafad2",
    "lightgrey": "#d3d3d3", "lightgreen": "#90ee90", "lightpink": "#ffb6c1", "lightsalmon": "#ffa07a", "lightseagreen": "#20b2aa", "lightskyblue": "#87cefa", "lightslategray": "#778899", "lightsteelblue": "#b0c4de",
    "lightyellow": "#ffffe0", "lime": "#00ff00", "limegreen": "#32cd32", "linen": "#faf0e6",
    "magenta": "#ff00ff", "maroon": "#800000", "mediumaquamarine": "#66cdaa", "mediumblue": "#0000cd", "mediumorchid": "#ba55d3", "mediumpurple": "#9370d8", "mediumseagreen": "#3cb371", "mediumslateblue": "#7b68ee",
    "mediumspringgreen": "#00fa9a", "mediumturquoise": "#48d1cc", "mediumvioletred": "#c71585", "midnightblue": "#191970", "mintcream": "#f5fffa", "mistyrose": "#ffe4e1", "moccasin": "#ffe4b5",
    "navajowhite": "#ffdead", "navy": "#000080",
    "oldlace": "#fdf5e6", "olive": "#808000", "olivedrab": "#6b8e23", "orange": "#ffa500", "orangered": "#ff4500", "orchid": "#da70d6",
    "palegoldenrod": "#eee8aa", "palegreen": "#98fb98", "paleturquoise": "#afeeee", "palevioletred": "#d87093", "papayawhip": "#ffefd5", "peachpuff": "#ffdab9", "peru": "#cd853f", "pink": "#ffc0cb", "plum": "#dda0dd", "powderblue": "#b0e0e6", "purple": "#800080",
    "rebeccapurple": "#663399", "red": "#ff0000", "rosybrown": "#bc8f8f", "royalblue": "#4169e1",
    "saddlebrown": "#8b4513", "salmon": "#fa8072", "sandybrown": "#f4a460", "seagreen": "#2e8b57", "seashell": "#fff5ee", "sienna": "#a0522d", "silver": "#c0c0c0", "skyblue": "#87ceeb", "slateblue": "#6a5acd", "slategray": "#708090", "snow": "#fffafa", "springgreen": "#00ff7f", "steelblue": "#4682b4",
    "tan": "#d2b48c", "teal": "#008080", "thistle": "#d8bfd8", "tomato": "#ff6347", "turquoise": "#40e0d0",
    "violet": "#ee82ee",
    "wheat": "#f5deb3", "white": "#ffffff", "whitesmoke": "#f5f5f5",
    "yellow": "#ffff00", "yellowgreen": "#9acd32"
};

//const colourJSON_CS = { Black: "#000000", Navy: "#000080", DarkBlue: "00008B", MediumBlue: "#0000CD", Blue: "#0000FF", DarkGreen: "#006400", Green: "#008000", Teal: "#008080", DarkCyan: "#008B8B", DeepSkyBlue: "#00BFFF", DarkTurquoise: "#00CED1", MediumSpringGreen: "#00FA9A", Lime: "#00FF00", SpringGreen: "#00FF7F", Aqua: "#00FFFF", Cyan: "#00FFFF", MidnightBlue: "#191970", DodgerBlue: "#1E90FF", LightSeaGreen: "#20B2AA", ForestGreen: "#228B22", SeaGreen: "#2E8B57", DarkSlateGray: "#2F4F4F", DarkSlateGrey: "#2F4F4F", LimeGreen: "#32CD32", MediumSeaGreen: "#3CB371", Turquoise: "#40E0D0", RoyalBlue: "#4169E1", SteelBlue: "#4682B4", DarkSlateBlue: "#483D8B", MediumTurquoise: "#48D1CC", Indigo: "#4B0082", DarkOliveGreen: "#556B2F", CadetBlue: "#5F9EA0", CornflowerBlue: "#6495ED", RebeccaPurple: "#663399", MediumAquaMarine: "#66CDAA", DimGray: "#696969", DimGrey: "#696969", SlateBlue: "#6A5ACD", OliveDrab: "#6B8E23", SlateGray: "#708090", SlateGrey: "#708090", LightSlateGray: "#778899", LightSlateGrey: "#778899", MediumSlateBlue: "#7B68EE", LawnGreen: "#7CFC00", Chartreuse: "#7FFF00", Aquamarine: "#7FFFD4", Maroon: "#800000", Purple: "#800080", Olive: "#808000", Gray: "#808080", Grey: "#808080", SkyBlue: "#87CEEB", LightSkyBlue: "#87CEFA", BlueViolet: "#8A2BE2", DarkRed: "#8B0000", DarkMagenta: "#8B008B", SaddleBrown: "#8B4513", DarkSeaGreen: "#8FBC8F", LightGreen: "#90EE90", MediumPurple: "#9370DB", DarkViolet: "#9400D3", PaleGreen: "#98FB98", DarkOrchid: "#9932CC", YellowGreen: "#9ACD32", Sienna: "#A0522D", Brown: "#A52A2A", DarkGray: "#A9A9A9", DarkGrey: "#A9A9A9", LightBlue: "#ADD8E6", GreenYellow: "#ADFF2F", PaleTurquoise: "#AFEEEE", LightSteelBlue: "#B0C4DE", PowderBlue: "#B0E0E6", FireBrick: "#B22222", DarkGoldenRod: "#B8860B", MediumOrchid: "#BA55D3", RosyBrown: "#BC8F8F", DarkKhaki: "#BDB76B", Silver: "#C0C0C0", MediumVioletRed: "#C71585", IndianRed: "#CD5C5C", Peru: "#CD853F", Chocolate: "#D2691E", Tan: "#D2B48C", LightGray: "#D3D3D3", LightGrey: "#D3D3D3", Thistle: "#D8BFD8", Orchid: "#DA70D6", GoldenRod: "#DAA520", PaleVioletRed: "#DB7093", Crimson: "#DC143C", Gainsboro: "#DCDCDC", Plum: "#DDA0DD", BurlyWood: "#DEB887", LightCyan: "#E0FFFF", Lavender: "#E6E6FA", DarkSalmon: "#E9967A", Violet: "#EE82EE", PaleGoldenRod: "#EEE8AA", LightCoral: "#F08080", Khaki: "#F0E68C", AliceBlue: "#F0F8FF", HoneyDew: "#F0FFF0", Azure: "#F0FFFF", SandyBrown: "#F4A460", Wheat: "#F5DEB3", Beige: "#F5F5DC", WhiteSmoke: "#F5F5F5", MintCream: "#F5FFFA", GhostWhite: "#F8F8FF", Salmon: "#FA8072", AntiqueWhite: "#FAEBD7", Linen: "#FAF0E6", LightGoldenRodYellow: "#FAFAD2", OldLace: "#FDF5E6", Red: "#FF0000", Fuchsia: "#FF00FF", Magenta: "#FF00FF", DeepPink: "#FF1493", OrangeRed: "#FF4500", Tomato: "#FF6347", HotPink: "#FF69B4", Coral: "#FF7F50", DarkOrange: "#FF8C00", LightSalmon: "#FFA07A", Orange: "#FFA500", LightPink: "#FFB6C1", Pink: "#FFC0CB", Gold: "#FFD700", PeachPuff: "#FFDAB9", NavajoWhite: "#FFDEAD", Moccasin: "#FFE4B5", Bisque: "#FFE4C4", MistyRose: "#FFE4E1", BlanchedAlmond: "#FFEBCD", PapayaWhip: "#FFEFD5", LavenderBlush: "#FFF0F5", SeaShell: "#FFF5EE", Cornsilk: "#FFF8DC", LemonChiffon: "#FFFACD", FloralWhite: "#FFFAF0", Snow: "#FFFAFA", Yellow: "#FFFF00", LightYellow: "#FFFFE0", Ivory: "#FFFFF0", White: "#FFFFFF" }


export const colorPallete = Object.values(coloursJSON).sort();
//export const colorPallete = Object.values(colourJSON_CS);//.sort();


export function colourNameToHex(colour) {
    var colours = coloursJSON;

    if (typeof colours[colour.toLowerCase()] != 'undefined')
        return colours[colour.toLowerCase()];

    return false;
}

export function colourHexToName(colour) {
    var colours = swap(coloursJSON);

    if (typeof colours[colour.toLowerCase()] != 'undefined')
        return colours[colour.toLowerCase()];

    return false;
}

/*
export function colourHexToNameCS(colour) {
    var colours = swap(colourJSON_CS);

    if (typeof colours[colour.toLowerCase()] != 'undefined') {
        return colours[colour.toLowerCase()];
    }
    return false;
}*/

function swap(json) {
    var ret = {};
    for (var key in json) {
        ret[json[key]] = key;
    }
    return ret;
}

export function decodeXml(xmlString: string, tagName: string): string {
    let oTag = "<" + tagName + ">";
    let cTag = "</" + tagName + ">";

    if (xmlString) {
        let arr1 = xmlString.split(oTag);
        let arr2 = arr1[1] ? arr1[1].split(cTag) : [null];
        return arr2[0];
    } else {
        return null;
    }
}

export function encodeXml(xmlString: string, tagName: string, tagValue: any): string {
    let oTag = "<" + tagName + ">";
    let cTag = "</" + tagName + ">";
    // text1 <t_o> text2 </t_c> text3
    //console.log("xmlll: ", xmlString);
    let arr = (xmlString) ? xmlString.split(oTag) : ['']; // before tag
    if (arr.length === 1 || !arr) {
        //console.log("xmlll1: ", xmlString + oTag + tagValue + cTag);
        // tag not found, adding tag
        return xmlString + oTag + tagValue + cTag;
    } else {
        // tag exists, update
        let text1 = arr[0]; // val
        let arr2 = arr[1].split(cTag); // aftertag
        //console.log("xmlll2: ", text1 + oTag + tagValue + cTag + arr2[1]);
        return text1 + oTag + tagValue + cTag + arr2[1];
    }
}

export type configObject = { showItems: Boolean, showPayments: Boolean, showTax: Boolean, isUnitCost: Boolean }

export function configByDocType(docType: Number): configObject/* { showItems: Boolean, showPayments: Boolean, showTax: Boolean, isUnitCost: Boolean }*/ {
    //const type = parseInt(this.props.documentType, 10);
    const type = parseInt(docType, 10);
    const defaultConfig = { showItems: false, showPayments: false, showTax: false, isUnitCost: false }

    switch (type) {
        case 1: // קבלה - חשבונית מס
            return { showItems: true, showPayments: true, showTax: true, isUnitCost: false }
        case 2: // חשבונית מס
        case 2005: // חשבונית מס מרכזת עם תיקונים
        case 202: // חשבונית מס באנגלית
            return { showItems: true, showPayments: false, showTax: true, isUnitCost: false }
        case 3: // קבלה
        case 203: // קבלה באנגלית
            return { showItems: false, showPayments: true, showTax: false, isUnitCost: false }
        case 4: // כניסת רכש 
            return { showItems: true, showPayments: false, showTax: true, isUnitCost: true }
        case 45051: // כניסת רכש // ריכוז מהעברות בין מחסנים
            return { showItems: false, showPayments: false, showTax: false, isUnitCost: true }
        case 40418: // כניסת רכש // ריכוז מתעודות משלוח רכש
            return { showItems: false, showPayments: false, showTax: false, isUnitCost: true }
        case 5: // ריכוז - חשבונית מס
            return { showItems: false, showPayments: false, showTax: false, isUnitCost: false }
        case 8: // תעודת משלוח
        case 208: // תעודת משלוח באנגלית
            return { showItems: true, showPayments: false, showTax: true, isUnitCost: false }
        case 9: // החזרת משלוח
            return { showItems: true, showPayments: false, showTax: true, isUnitCost: false }
        case 10: // שובר זיכוי
            return defaultConfig
        case 11: // ספרית מלאי
            return { showItems: true, showPayments: false, showTax: false, isUnitCost: false }
        case 12: // תעודת תיקון 
        case 13: // הפרשי מלאי
        case 14: // הזמנה באתר
            return defaultConfig
        case 15: // הזמנה מספק
        case 215: // הזמנה מספק באנגלית
            return { showItems: true, showPayments: false, showTax: false, isUnitCost: true }
        case 16: // חשבונית רכש
        case 17: // זיכוי רכש
            return { showItems: true, showPayments: false, showTax: false, isUnitCost: true }
        case 18: // החזרת רכש
            return { showItems: true, showPayments: false, showTax: false, isUnitCost: true }
        case 19: // הזמנת לקוח
        case 219: // הזמנת לקוח באנגלית
            return { showItems: true, showPayments: false, showTax: false, isUnitCost: false }
        case 20: // חשבונית מס (לספק)
            return { showItems: true, showPayments: false, showTax: true, isUnitCost: true }
        case 21: // חשבונית מס זיכוי (לספק)
            return { showItems: true, showPayments: false, showTax: true, isUnitCost: true }
        case 22: // חשבונית מס זיכוי
        case 222: // חשבונית מס זיכוי באנגלית
            return { showItems: true, showPayments: false, showTax: true, isUnitCost: false }
        case 23: // החזרת כסף
            return { showItems: false, showPayments: true, showTax: false, isUnitCost: false }
        case 30: // הצעת מחיר
        case 230: // הצעת מחיר באנגלית
            return { showItems: true, showPayments: false, showTax: false, isUnitCost: false }
        case 31: //   הצעת מחיר מספק
            return { showItems: true, showPayments: false, showTax: false, isUnitCost: true }
        case 40: // הכנסת כסף
        case 41: // הוצאת כסף
            return defaultConfig
        case 50: // יציאה - העברה בין מחסנים
        case 51: // כניסה -העברה בין מחסנים
        case 5051: // העברה בין מחסנים
        case 5150: // העברה בין מחסנים // Just in case id order is mixed
            return { showItems: true, showPayments: false, showTax: false, isUnitCost: false/*true*/ }
        case 53: //
            return { showItems: false, showPayments: true, showTax: false, isUnitCost: false }
        case 90: // רשומת לקוח
        case 99: // Z
            return defaultConfig
        default:
            return defaultConfig;
    }
}

export function escapeRegExp(text) {
    return text ?
        text.trim()
            .replace(/\s\s+/g, ' ')
            .replace(/\\/g, "\\\\\\\\")
            .replace(/\'/g, "\\\'")
            .replace(/\"/g, "\\\"")
            .replace(/[-[\]{}()*+?.,^$|#]/g, '\\\\$&')
        : "";
}

export function disabledDatePicker(date, minDate, maxDate) {
    const formatDate = moment(date).format("YYYY-MM-DD");
    if (minDate && formatDate.valueOf() < minDate.valueOf()) return true;
    if (maxDate && formatDate.valueOf() > maxDate.valueOf()) return true;
    return false;
}

export function isTrue(val) {
    return val ? val : null
}